import Modal from "src/components/Common/UI/Modal/Modal";
import Button from "../Common/UI/Forms/Button";
import { useRef } from "react";
import { format } from 'date-fns';

const ModalNotification = (props: ModalNotificationProps) => {
  const {alertVisibility, message, type} = props;
  const downloadAnchorRef = useRef<HTMLAnchorElement>(null);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(message).then(() => {
      alert('Το κείμενο αντιγράφηκε στο πρόχειρο!');
    }).catch((err) => {
      console.error('Failed to copy text: ', err);
    });
  };

  const downloadTextFile = () => {
    const blobString = message; 
    const recordingsBlob = new Blob([blobString], { type: 'text/plain' });
    const recordingsBlobURL = URL.createObjectURL(recordingsBlob);

    const currentDate = new Date();
    const nowDateFormatted = format(currentDate, 'yyyy-MM-dd_HH-mm-ss');
    const fileName = `syd_export_${nowDateFormatted}.txt`;

    if (downloadAnchorRef.current) {
      downloadAnchorRef.current.href = recordingsBlobURL;
      downloadAnchorRef.current.download = fileName;
      downloadAnchorRef.current.click();
      
      setTimeout(() => URL.revokeObjectURL(recordingsBlobURL), 100);
    }
  };

  return (
    <Modal
      isOpen={true}
      closeFilterModal={alertVisibility}
      title={""}  
      size="sm"
    > 
      <>
        <a ref={downloadAnchorRef} href="#" style={{ display: 'none' }}>Download</a>
        {message}
        <hr />
        <div className="mt-3 text-center">
          <Button
            type="submit"
            size="sm"
            styletype="primary"
            onClick={copyToClipboard}
          >
            Αντιγραφή
          </Button>
          <Button
            type="submit"
            size="sm"
            styletype="primary"
            onClick={downloadTextFile}
          >
            Λήψη
          </Button>
        </div>
      </>
    </Modal>
  )
}

export default ModalNotification;

interface ModalNotificationProps {
  type: "success" | "danger" | "warning";
  message: string;
  alertVisibility: () => void;
}
